import React, { useEffect, useRef } from 'react';
import SideModal from 'library/components/side-modal/side-modal';
import JourneySideModalFooter from 'apps/journey/components/modals/journey-side-modal/journey-side-modal-footer';
import JourneySideModalHeading from 'apps/journey/components/modals/journey-side-modal/journey-side-modal-heading';
import {
  StyledJourneyModalContent,
  StyledJourneyModalInner,
  StyledMainContent,
} from './styled-journey-side-modal';

const JourneySideModal = ({
  icon,
  header,
  description,
  children,
  footer,
  toggleActive,
  active,
  descriptionStyle,
}) => {
  const modalRef = useRef(null);
  useEffect(() => {
    requestAnimationFrame(() => {
      if (active) {
        window.prevFocus = document.activeElement;
        modalRef?.current?.focus();
      } else {
        window?.prevFocus?.focus();
      }
    });
  }, [active]);
  return (
    <SideModal active={active} toggleActive={toggleActive}>
      <StyledJourneyModalInner tabIndex={0} ref={modalRef}>
        <StyledJourneyModalContent footer={!!footer}>
          <StyledMainContent>
            <JourneySideModalHeading
              icon={icon}
              header={header}
              description={description}
              toggleActive={toggleActive}
              descriptionStyle={descriptionStyle}
            />
            {children}
          </StyledMainContent>
        </StyledJourneyModalContent>
        {footer && <JourneySideModalFooter> {footer} </JourneySideModalFooter>}
      </StyledJourneyModalInner>
    </SideModal>
  );
};

export default JourneySideModal;
